import { SelectOptionUi } from '@/components/Select/SelectUi';

export type FiscalDataUi = {
  taxInvoiceRequired: boolean;
  rfc: string;
  rfcError?: string;
  fiscalRegime: string;
  fiscalRegimeError?: string;
  legalName: string;
  legalNameError?: string;
  cfdiUse: string;
  cfdiUseError?: string;
  postalCode: string;
  postalCodeError?: string;
  taxEmail: string;
  taxEmailError?: string;
  cancelDisabled: boolean;
  saveDisabled: boolean;
  fiscalRegimeOptions: SelectOptionUi[];
  cfdiUseOptions: SelectOptionUi[];
};

export const initialState: FiscalDataUi = {
  taxInvoiceRequired: false,
  rfc: '',
  legalName: '',
  postalCode: '',
  taxEmail: '',
  cancelDisabled: true,
  saveDisabled: true,
  fiscalRegime: '',
  cfdiUse: '',
  fiscalRegimeOptions: [],
  cfdiUseOptions: [],
};
